"use strict";

define('view/report.iframe',['underscore', 'marionette', 'uikit/collections/container', 'uikit/mixins/component.mixin', '../templates'], function (_, Mn, Container, ComponentMixin, Templates) {
  var IFrame = Mn.ItemView.extend(ComponentMixin).extend({
    tagName: 'div',
    className: 'reports beta',
    template: Templates.IRB['iframe'],
    options: {
      host: '',
      token: ''
    },
    attributes: {},
    getReportUrl: function getReportUrl() {
      return '' + this.options.host + '&id_token=' + this.options.token;
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.once('before:render', this.onBeforeFirstRender, this);
      this.on('attach', this.onAttach, this);
      this.on('destroy', this.onDestroy, this);
    },
    onBeforeFirstRender: function onBeforeFirstRender() {
      var url = '' + this.options.host + '&id_token=' + this.options.token;
      this.options.iframeSrc = url;
      this.options.showIframe = this.options.token && this.options.token.length > 0;
      if (window.addEventListener) {
        window.addEventListener('message', this.handleMessageFromIframe, false);
      } else if (window.attachEvent) {
        window.attachEvent('onmessage', this.handleMessageFromIframe());
      }
    },
    onBeforeRender: function onBeforeRender() {},
    onAttach: function onAttach() {
      var iframe = document.getElementById('reportingFrame').contentWindow;
      if (iframe) {
        iframe.postMessage(this.options.token);
      }
    },
    onDestroy: function onDestroy() {
      if (window.removeEventListener) {
        window.removeEventListener('message', this.handleMessageFromIframe, false);
      } else if (window.attachEvent) {
        window.detachEvent('onmessage', this.handleMessageFromIframe());
      }
    },
    handleMessageFromIframe: function handleMessageFromIframe(e) {
      var iframe = document.getElementById('reportingFrame').contentWindow;
      if (e.source == iframe) {
        console.log("Message from iframe: " + e.data);
      } else {
        console.log("Message from other source: " + JSON.stringify(e));
      }
    }
  });
  return IFrame;
});

